import React, { useCallback } from 'react';
import * as Sentry from '@sentry/nextjs';
import SEO from '@/common/components/head/Seo';
import Layout, { styles as layoutStyles } from '@/components/layouts/Public';
import PricingTable from '@/components/misc/PricingTable';
import useStripeAccount from '@/hooks/useStripeAccount';
import { useToast } from '@/hooks/useToast';
import logger from '@/utils/logger';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Pricing = _ref => {
  let {
    user,
    team
  } = _ref;
  const {
    addToast: sendNotification
  } = useToast();
  const {
    redirectToBilling,
    redirectToCheckout
  } = useStripeAccount(user);
  const handleRedirectBilling = useCallback(() => {
    redirectToBilling().catch(err => {
      Sentry.captureException(err);
      logger.error(err);
      sendNotification({
        type: 'error',
        description: err.userMessage || 'Unexpected error, please try again or message chat for support.'
      });
    });
  }, [redirectToBilling, sendNotification]);
  const handleRedirectCheckout = useCallback(async priceId => {
    return redirectToCheckout(priceId).catch(err => {
      Sentry.captureException(err);
      logger.error(err);
      sendNotification({
        type: 'error',
        description: err.userMessage || 'Unexpected error, please try again or message chat for support.'
      });
    });
  }, [redirectToCheckout, sendNotification]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SEO, {
      title: "Pricing"
    }), /*#__PURE__*/_jsx(Layout, {
      className: layoutStyles.container,
      children: /*#__PURE__*/_jsx("section", {
        className: layoutStyles.section,
        children: /*#__PURE__*/_jsxs("div", {
          className: "container my-32 mx-auto",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "mx-auto mb-20 max-w-screen-lg text-center",
            children: [/*#__PURE__*/_jsx("h2", {
              className: "mb-3 text-pretty text-4xl font-bold lg:text-6xl",
              children: "Pricing"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-muted-foreground lg:text-xl",
              children: "Check out our affordable pricing plans below and choose the one that suits you best. If you need a custom plan, please contact us."
            })]
          }), /*#__PURE__*/_jsx(PricingTable, {
            team: team,
            redirectToBilling: handleRedirectBilling,
            redirectToCheckout: handleRedirectCheckout
          })]
        })
      })
    })]
  });
};

export default Pricing;